// @Version: 1.0.0
export enum SESSIONINFOERROR {
   ENTRYURL = 'ENTRYURL'
}